module.exports = __webpack_public_path__ + "assets/5588b948d050bfe4e24f10ad2f6306a6.png";